import React, { Component } from 'react';

export class HeaderTile extends Component {
    render() {
        return (
            <div className={"tile "+ this.props.className}><img alt="energy type" src={this.props.icon}/><h3>{this.props.title}</h3><p>{this.props.blurb}</p></div>
        );
    }
}